<template>
	<button v-if="children && children.length==0" @click="$emit('test',{hist:hist_unit_id,depl:depl_unit_id})">{{hist_unit_name}}</button>
	<div v-else>
		<recursiveButton v-for="(nested,i) in children" :key="i" v-bind="nested" @test="$emit('test',$event)"></recursiveButton>
	</div>
</template>

<script>
import recursiveButton from "./DivLinkButton";
export default {
  name: "recursiveButton",
  components: {
      recursiveButton,
    },
    props: {
      depl_unit_id: {
        type: Number,
        default: null
      },
	  hist_unit_id: {
        type: Number,
        default: null
      },
      hist_unit_name: String,
      children: {
        type: Array,
        default: function () {
          return [];
        }
      },
      faction: {
        type: Number,
        default: null
      },
      image: {
        type: String,
        default: null
      }

    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/basic_comp/recursiveButton.vue